/* O'Stori — Panels (Framer-style) — Scoped controller
   - Section rendering safe (Theme Editor)
   - Accessible toggle: click/tap + Enter/Space + Esc collapse
*/

class OstoriPanels extends HTMLElement {
  connectedCallback() {
    this._root = this;
    this._wrap = this.querySelector('[data-ostori-panels-wrap]');
    this._panels = Array.from(this.querySelectorAll('[data-ostori-panel]'));
    this._activeIndex = -1;

    if (!this._wrap || this._panels.length === 0) return;

    // Bind
    this._onClick = this._onClick.bind(this);
    this._onKeyDown = this._onKeyDown.bind(this);

    // Events
    this.addEventListener('click', this._onClick);
    this.addEventListener('keydown', this._onKeyDown);

    // Theme Editor hooks (safe no-ops outside editor)
    document.addEventListener('shopify:section:unload', (e) => {
      if (e.detail?.sectionId === this.dataset.sectionId) this.destroy();
    });

    document.addEventListener('shopify:block:select', (e) => {
      if (e.detail?.sectionId !== this.dataset.sectionId) return;
      const blockId = e.detail?.blockId;
      const idx = this._panels.findIndex(p => p.dataset.blockId === blockId);
      if (idx > -1) this.setActive(idx);
    });

    document.addEventListener('shopify:block:deselect', (e) => {
      if (e.detail?.sectionId !== this.dataset.sectionId) return;
      // keep state; no auto-collapse
    });

    // Initial: collapsed
    this._sync();
  }

  destroy() {
    this.removeEventListener('click', this._onClick);
    this.removeEventListener('keydown', this._onKeyDown);
  }

  _onClick(e) {
if (e.target.closest('[data-ostori-cta]')) return;
const btn = e.target.closest('[data-ostori-panel-btn]');
    if (!btn) return;

    const panel = btn.closest('[data-ostori-panel]');
    const idx = this._panels.indexOf(panel);
    if (idx === -1) return;

    if (this._activeIndex === idx) {
      this.collapse();
    } else {
      this.setActive(idx);
    }
  }

  _onKeyDown(e) {
    const isEnter = e.key === 'Enter';
    const isSpace = e.key === ' ';
    const isEsc = e.key === 'Escape';

    if (isEsc && this._activeIndex !== -1) {
      e.preventDefault();
      this.collapse();
      return;
    }

    if (!isEnter && !isSpace) return;

    const btn = e.target.closest('[data-ostori-panel-btn]');
    if (!btn) return;

    e.preventDefault();
    const panel = btn.closest('[data-ostori-panel]');
    const idx = this._panels.indexOf(panel);
    if (idx === -1) return;

    if (this._activeIndex === idx) {
      this.collapse();
    } else {
      this.setActive(idx);
    }
  }

  setActive(idx) {
    this._activeIndex = idx;
    this._sync();
  }

  collapse() {
    this._activeIndex = -1;
    this._sync();
  }

  _sync() {
    const hasActive = this._activeIndex !== -1;
    this.dataset.hasActive = hasActive ? 'true' : 'false';

    this._panels.forEach((panel, i) => {
      const isActive = hasActive && i === this._activeIndex;
      const isInactive = hasActive && i !== this._activeIndex;

      panel.classList.toggle('is-active', isActive);
      panel.classList.toggle('is-inactive', isInactive);

      const btn = panel.querySelector('[data-ostori-panel-btn]');
      if (btn) {
        btn.setAttribute('aria-expanded', isActive ? 'true' : 'false');
      }
    });
  }
}

if (!customElements.get('ostori-panels')) {
  customElements.define('ostori-panels', OstoriPanels);
}